import { combineReducers } from 'redux';

import contributor from './contributor';
import distribution from './distribution';
import revenue from './revenue';
import severity from './severity';
import top from './top';

export default combineReducers({
  top,
  revenue,
  severity,
  contributor,
  distribution,
});
